// extracted by mini-css-extract-plugin
module.exports = {"ratings-reviews-msg-heading":"ComingSoon_ratings-reviews-msg-heading__ODf7i","ratings-reviews-msg-desc":"ComingSoon_ratings-reviews-msg-desc__b2Kpb"};